module.exports = __webpack_public_path__ + "img/tree-4.57ba1479.png";